// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

const menuOpen = document.querySelector('.menu-open')
const menuClose = document.querySelector('.menu-close')
const menu = document.querySelector('.menu')
const menuOverlay = document.querySelector('.menu-overlay')

function openMenu(): void {
  if (!menu) return
  menu.classList.add('transition-transform', 'duration-300', 'ease-in-out')
  menu.classList.remove('translate-x-full')
  menu.classList.add('translate-x-0')
  menuOverlay?.classList.remove('opacity-0', 'pointer-events-none')
  menuOverlay?.classList.add('opacity-100')
  document.body.classList.add('overflow-hidden')
}

function closeMenu(): void {
  if (!menu) return
  menu.classList.remove('translate-x-0')
  menu.classList.add('translate-x-full')
  menuOverlay?.classList.remove('opacity-100')
  menuOverlay?.classList.add('opacity-0', 'pointer-events-none')
  document.body.classList.remove('overflow-hidden')
}

menuOpen?.addEventListener('click', openMenu)
menuClose?.addEventListener('click', closeMenu)
menuOverlay?.addEventListener('click', closeMenu)


const initNonCritical = async () => {

  // Lazy load video handling
   const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]');
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }


 /*
    Intersecting elements helper
*/
 const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  )as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

const NewsArchive = document.getElementById('news-archive')
if (NewsArchive && NewsArchive !== null) {
  import('./NewsArchive/index.ts')
    .then((module) => {
      module.default(NewsArchive as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
    })
}

const ContactForm = document.getElementById('contact-form')
if (ContactForm && ContactForm !== null) {
  import('./ContactForm/index.ts')
    .then((module) => {
      module.default(ContactForm as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
    })
}

      const WhistleblowerForm = document.getElementById('whistleblower-form')
      if (WhistleblowerForm && WhistleblowerForm !== null) {
  import('./WhistleblowerForm/index.ts')
    .then((module) => {
      module.default(WhistleblowerForm as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
    })
}